module.exports = __webpack_public_path__ + "static/img/医疗卡片1_选中状态@2x.5469f73d.png";